import React from 'react';
import { Button, Dialog } from '@teachstonellc/component-library';
import i18n from 'helpers/i18n';
import messages from './messages';

// `Button` has no destructive variant. The solid-hover shade is used as the
// resting color because white text on solid-resting fails AA contrast.
const destructiveClassName =
  '!bg-ds-action-negative-solid-hover hover:!bg-ds-action-negative-solid-pressed ' +
  'active:!bg-ds-tomato-11 focus-visible:!ring-ds-action-negative-solid-focus';

interface RemoveNumberProps {
  /** Callback used to execute a function. */
  onSuccess: () => void;

  /** Boolean used to open the modal. */
  open: boolean;

  /** Callback used to change the boolean that open the alert. */
  handleAlert: () => void;

  /** Boolean used to show different messages. */
  isVerified: boolean;
}

const RemovePhoneModal: React.FC<RemoveNumberProps> = ({
  onSuccess,
  open,
  handleAlert,
  isVerified
}) => {
  function handleOpenChange(isOpen: boolean) {
    if (!isOpen) {
      handleAlert();
    }
  }

  function confirm() {
    onSuccess();
    handleAlert();
  }

  return (
    <Dialog
      open={open}
      onOpenChange={handleOpenChange}
      title={i18n.ft(messages.deletePhoneNumber.title)}
      description={
        isVerified
          ? i18n.ft(messages.deletePhoneNumber.alertVerified)
          : i18n.ft(messages.deletePhoneNumber.alertNotVerified)
      }
      closeButton={
        <Button type="button" variant="secondary">
          {i18n.ft(messages.deletePhoneNumber.cancel)}
        </Button>
      }
      actionButton={
        <Button
          type="button"
          variant="primary"
          onClick={confirm}
          className={destructiveClassName}
        >
          {i18n.ft(messages.deletePhoneNumber.deleteAction)}
        </Button>
      }
    />
  );
};

export default RemovePhoneModal;
